export default class SearchEventsRmc{

    constructor(element) {
        this._wrapper = element;
        
        this.bindEvents();
    }
    
    bindEvents(){
        document.addEventListener('facetwp-refresh', function() {
            Object.entries(FWP.facets).forEach(([key, value]) => {
                let _facet = document.querySelector('.facetwp-facet[data-name="'+key+'"]');
                if(value.length){
                    _facet.classList.add('has-value');
                }
                else{
                    _facet.classList.remove('has-value');
                }
            });
        });
    }


}